export function NotionComponent() {
  return (
    <div className="bg-red-600 w-full h-[40px] block items-center justify-center">
      <p className="text-[24px] text-center text-white">
        Segala tindakan yang anda lakukan, di awasi CCTV!
      </p>
    </div>
  );
}
